import {Actions} from "../Context"
import {setStorageData} from "../../utils/index";
import Stages from "../../stages/login";

const getStageById = id => {
    return Stages.filter(stage => {
        return stage.id === id;
    })[0];
};

const getDirection = (currentStage, nextStage) => {
    return Stages.indexOf(currentStage) < Stages.indexOf(nextStage)
        ? "next"
        : "prev";
};

const getNextStage = (currentStage, toStage) => {
    const nextStage = getStageById(toStage);
    return {
        currentStage: nextStage,
        direction: getDirection(currentStage, nextStage)
    };
};

const getSelectedTeam = (_userTeams, _selectedTeam) => {
    return _userTeams.filter((_team) => {
        return _team.TeamMemberID === _selectedTeam.TeamMemberID
    })[0];
};

let currentUserTeam;

export default (state, action) => {
    // console.log("got action", action);
    switch (action.type) {

        case Actions.TO_STAGE:
            return {
                ...state,
                ...getNextStage(state.currentStage, action.payload.toStage)
            };

        case Actions.USER_ALREADY_LOGGED_IN:
            const {loginTeams, sid} = action.payload;
            setStorageData('loginTeams', loginTeams);
            return {
                ...state,
                loginTeams,
                sid,
                loggedIn: true,
                ...getNextStage(
                    state.currentStage,
                    "team-select"
                )
            };

        case Actions.SELECTED_FORGOT_PASSWORD:
            return {

                ...state,
                ...getNextStage(state.currentStage, "forgot-password")
            };

        case Actions.RECEIVED_LINK_ACCOUNTS_REQUEST:
            return {
                ...state,
                linkAccounts: action.payload,
                userNotFound: null
            };

        case Actions.RECEIVED_USER_NOT_FOUND_RESPONSE:
            return {
                ...state,
                userNotFound: action.payload
            };

        case Actions.RECEIVED_USER_TEAMS_DATA:
            const {teams, auth} = action.payload;
            setStorageData('loginTeams', teams);
            let newStateObj = {
                ...state,
                auth,
                loginTeams: teams,
                userNotFound: null,
                linkAccounts: null,
            };
            if (teams.length > 1) {
                newStateObj = Object.assign({}, newStateObj, {...getNextStage(
                    state.currentStage,
                    "team-select"
                )});
            }
            return newStateObj;

        case Actions.SELECTED_TEAM:
            const {team} = action.payload;
            return {
                ...state,
                selectedTeam: team,
            };

        case Actions.SELECTED_LOGGED_IN_TEAM:
            try {
                currentUserTeam = getSelectedTeam(state.loginTeams, state.selectedTeam);
            } catch (err) {
                throw new Error('Could not match user team');
            }
            setStorageData('user', currentUserTeam);
            window.tsUtilityModals.loginCompleteCallback(currentUserTeam);
            return {
                ...state,
                selectedTeam: team,
            };

        case Actions.RECEIVED_SESSION_DATA:
            setStorageData('sid', action.payload.sessionId);
            setStorageData('userTeams', action.payload.users);
            try {
                currentUserTeam = getSelectedTeam(action.payload.users, state.selectedTeam);
            } catch (err) {
                throw new Error('Could not match user team');
            }
            setStorageData('user', currentUserTeam);
            window.tsUtilityModals.loginCompleteCallback(currentUserTeam);
            return {
                ...state,
                user: currentUserTeam,
                selectedTeam: null,
                ...getNextStage(
                    state.currentStage,
                    "team-select"
                )
            };
        case Actions.CANCELLED_LOGIN:
            window.tsUtilityModals.loginCancelCallback(state);
            if (state.loggedIn) {
                return {
                    ...state,
                };
            }
            return {
                ...state,
                loginTeams: null,
                userNotFound: null,
                linkAccounts: null,
                user: null,
                selectedTeam: null,
                ...getNextStage(
                    state.currentStage,
                    "login-method"
                )
            };
        default:
            return {...state};
    }
};
